"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @figma designed by Gabe Kelley, Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1791))
 * @trackcomponent
 * @lastsynced 2025-04-16T17:02:15.415Z
 * @optimized using svgo:^3.0.2
 */
export const Euro = createSVGIcon(
  <>
    <path
      d="M.5 12.5a12 12 0 1 0 24 0 12 12 0 0 0-24 0Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.25 11.205c0 .27.22.49.49.49h.708v1.316H7.74a.49.49 0 1 0 0 .979h.76c.304 2.616 1.958 4.506 4.54 4.506 2.097 0 3.601-1.173 4.09-3.207.095-.4-.23-.759-.641-.759-.343 0-.628.254-.716.585-.387 1.44-1.34 2.183-2.733 2.183-1.84 0-2.87-1.232-3.089-3.308h2.988a.49.49 0 0 0 0-.979H9.9v-1.316h3.476a.49.49 0 1 0 0-.98H9.934c.219-2.092 1.265-3.442 3.071-3.442 1.295 0 2.231.705 2.606 1.96.1.332.385.588.73.588.417 0 .745-.366.639-.768-.492-1.859-1.93-2.928-3.975-2.928-2.666 0-4.236 2.008-4.506 4.59h-.76a.49.49 0 0 0-.489.49"
      fill="currentColor"
    />
  </>,
  "Euro",
  { viewBox: "0 0 25 25", fill: "none", color: Core.icon.default } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
